import classNames from 'classnames';
import React from 'react';
import useStyles from './styles';
import { icons } from '../../utils/icons';
import { Avatar } from '@material-ui/core';

export default function Checkbox(props) {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.container,
        props.containerContainerClass && props.containerContainerClass
      )}
    >
      <div
        className={classNames(
          classes.check_container,
          props.checked && classes.checkedContainer,
          props.checkboxContainerClass && props.checkboxContainerClass,
          props.checked &&
            props.checkedContainerClass &&
            props.checkedContainerClass
        )}
        onClick={() => props.onChange && props.onChange(props.value)}
      >
        {props.checked && (
          <img
            className={classes.checked_icon}
            src={icons().rightIcon}
            alt=''
          />
        )}
      </div>
      {props.image && (
        <Avatar
          style={{ width: 32, height: 32, marginLeft: 10 }}
          alt={props.label}
          src={props.image}
        />
      )}
      {props.color && !props.image && (
        <div
          style={{
            width: 32,
            height: 32,
            marginLeft: 10,
            borderRadius: '50%',
            backgroundColor: props.color,
          }}
        />
      )}
      {props.label && (
        <label
          className={classNames(
            classes.check_label,
            props.labelClassName && props.labelClassName
          )}
        >
          {props.label}
        </label>
      )}
    </div>
  );
}
